import { Platform } from 'react-native'
import * as S from './dropdown-list.styles'

import { OptionMenu } from '~/components/option-menu'

import { useTheme } from '~/hooks'

import {
  DisplayNames,
  type ScopedProps,
  useInputMultiSelectContext,
} from '../../input-multi-select.context'

import { HELPER_TEXT_HEIGHT } from '../helper-text'

type InputMultiSelectDropdownProps = {
  onConfirm?(): void
  onCancel?(): void
  testID?: string
}

export const InputMultiSelectDropdownList: React.FC<
  InputMultiSelectDropdownProps
> = externalProps => {
  const { __scopeInputMultiSelect, onConfirm, onCancel, testID } =
    externalProps as ScopedProps<InputMultiSelectDropdownProps>

  const theme = useTheme()

  const spaceBetweenSelectAndDropdown =
    Platform.OS === 'ios' ? theme.spacingStackOnepulse + HELPER_TEXT_HEIGHT : 0

  const {
    options,
    confirmedOptionsSelected,
    temporaryOptionsSelected,
    handleTempOptionSelected,
    confirmSelectionsMadeByUser,
    removeSelectedOption,
    handleControlFocusState,
    controlLayoutInfo,
  } = useInputMultiSelectContext(
    DisplayNames.DROPDOWN_LIST,
    __scopeInputMultiSelect
  )

  function handleDropdownConfirm() {
    onConfirm?.()
    confirmSelectionsMadeByUser()

    handleControlFocusState('blur')
  }

  function handleDropdownCancel() {
    onCancel?.()
    handleControlFocusState('blur')
    handleTempOptionSelected('discard')
  }

  return (
    <S.Container
      testID={testID}
      collapsable={false}
      style={{
        width: controlLayoutInfo.width,

        top: controlLayoutInfo.y + spaceBetweenSelectAndDropdown,
        left: controlLayoutInfo.x,
      }}
    >
      <OptionMenu.Root type="multi">
        <OptionMenu.List>
          {options.map(({ id, label, description, value }) => {
            const isChecked = [
              ...confirmedOptionsSelected,
              ...temporaryOptionsSelected!,
            ].some(option => option.id === id)

            return (
              <OptionMenu.Item
                testID={`input-multi-select-(option-${id})`}
                key={id}
                content={{
                  label,
                  description: description ?? '',
                }}
                checked={isChecked}
                onPress={() => {
                  if (!isChecked) {
                    handleTempOptionSelected('add', {
                      id,
                      label,
                      description,
                      value,
                    })
                  } else {
                    removeSelectedOption(id)
                  }
                }}
              />
            )
          })}
        </OptionMenu.List>

        <OptionMenu.Footer
          controls={[
            {
              type: 'confirm',
              label: 'Confirmar',
              handler: handleDropdownConfirm,
            },
            {
              type: 'cancel',
              label: 'Cancelar',
              handler: handleDropdownCancel,
            },
          ]}
        />
      </OptionMenu.Root>
    </S.Container>
  )
}

InputMultiSelectDropdownList.displayName = DisplayNames.DROPDOWN_LIST
